import {HeaderMeasure} from "@modules/HeaderFooterMeasurement"
import {owdCarousel,owdCarouselAuto} from "@modules/CarouselModule";
import {TabsChanges} from "@components/TabsChanges";
import {inputAction} from "@components/AmountInput";
import {modalAction} from "@components/ModalAction";
import { CodeCopy } from "@components/CodeCopy";
import {YoutubePopup,lvideoClose} from "@components/YoutubePopup";
import {MovieDataPush} from "@components/MovieDataPush"
import LayoutHeader from "@modules/layout/default/header/LayoutHeader.svelte"
import InterestRateSimulation from "@modules/InterestRateSimulation.svelte"
import LayoutFooter from "@modules/layout/default/footer/LayoutFooter.svelte"
import BusinessLayoutFooter from "@modules/layout/business/footer/BusinessLayoutFooter.svelte"
import BusinessLayoutHeader from "@modules/layout/business/header/BusinessLayoutHeader.svelte"
import DebitcardGiudeHowto from "@modules/page/debit-card/PageDebitcardGiudeHowto.svelte"
import DebitcardGuideAbout from "@modules/page/debit-card/PageDebitcardGiudeAbout.svelte"
import DebitcardGuidePlace from "@modules/page/debit-card/PageDebitcardGiudePlace.svelte"
import LoanGiudeFixedRepayment from "@modules/page/loan/PageLoanGiudeFixedRepayment.svelte"
import LoanGiudeRepaymentSimulation from "@modules/page/loan/PageLoanGiudeRepaymentSimulation.svelte"
import LoanGiudeIncrease from "@modules/page/loan/PageLoanGiudeIncrease.svelte"
import SnsContents from "@modules/SnsContents.svelte"
import ProjectVoiceCase from "@modules/page/voice/ProjectVoiceCase.svelte"
import ProjectVoiceCaseItems from "@modules/page/voice/ProjectVoiceCaseItems.svelte"
import LoanSimulate from "@modules/page/loan/LoanSimulate.svelte"
import LayoutContent from "@modules/LayoutContent.svelte"
import {OldAnimations} from "@modules/Animation"

// text Insert
import { RateTextInsert,DateTextInsert } from "@components/DynamicTextInsert";



// svelte custom Elements newはしなくていい
import ColumnFetch from "@ce/ColumnFetch.svelte"
import FavColumnFetch from "@ce/FavColumnFetch.svelte"
import NewColumnFetch from "@ce/NewColumnFetch.svelte"
import SectionHead from "@ce/SectionHead.svelte"
import PageHeader from "@ce/PageHeader.svelte"
import CtaButton from "@ce/CtaButton.svelte"
import AppDownloadModal from "@ce/AppDownloadModal.svelte"
import Keyvisual from "@ce/Keyvisual.svelte"
import FeatureService from "@ce/FeatureService.svelte"
import Faq from "@ce/Faq.svelte"
import FixedBanner from "@ce/FixedBanner.svelte"
import ModalContentDefault from "@ce/ModalContentDefault.svelte"

// import "../style/old/styles.scss";
// import "@assets/style/styles.scss";

import { mount } from 'svelte';
// 要素が出現するのを待ってからマウントするヘルパー関数
const mountWhenReady = (id, Component) => {
  const target = document.getElementById(id);

  if (target) {
    // 既にあれば即マウント
    mount(Component, { target });
  } else {
    // なければ出現を監視する
    const observer = new MutationObserver((mutations, obs) => {
      const el = document.getElementById(id);
      if (el) {
        mount(Component, { target: el });
        obs.disconnect(); // 見つかったら監視終了
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }
};

document.addEventListener("DOMContentLoaded",()=> {
  if(window.location.pathname.includes('/app/apptoweb/')) {
    const elements = document.querySelectorAll('.modal-none');
    elements.forEach(el => {
      el.style.display = 'block';
      console.log("/app/apptoweb/での.modal-noneをblockに");
    });
  }

  const isApple = /Mac|iPhone|iPad|iPod/.test(navigator.userAgent);

  if (isApple) {
    document.documentElement.classList.add('is-apple');
}

  HeaderMeasure()
  owdCarousel()
  owdCarouselAuto()
  TabsChanges()
  inputAction()
  modalAction()
  YoutubePopup()
  lvideoClose()
  MovieDataPush()
  RateTextInsert()
  DateTextInsert()
  CodeCopy()
  OldAnimations()

  const Header = document.getElementById("layout-header")
  Header? mount(LayoutHeader, { target: Header }):null;

  const Simulation = document.getElementById("rates-simulation")
  Simulation? mount(InterestRateSimulation, { target: Simulation }):null;

  const Footer = document.getElementById("layout-footer")
  Footer? mount(LayoutFooter, { target: Footer }):null;
  const BizFooter = document.getElementById("layout-business-footer")
  BizFooter? mount(BusinessLayoutFooter, { target: BizFooter }):null;
  const BizHeader = document.getElementById("layout-business-header")
  BizHeader? mount(BusinessLayoutHeader, { target: BizHeader }):null;
  const SnsContentsId = document.getElementById("sns-contents")
  SnsContentsId? mount(SnsContents, { target: SnsContentsId }):null;
  const ProjectVoiceCaseId = document.getElementById("owd-voice-case")
  ProjectVoiceCaseId? mount(ProjectVoiceCase, { target: ProjectVoiceCaseId }):null;
  const ProjectVoiceCaseItemsID = document.getElementById("owd-voice-case-items")
  ProjectVoiceCaseItemsID? mount(ProjectVoiceCaseItems, { target: ProjectVoiceCaseItemsID }):null;
  const LoanSimulateID = document.getElementById("owd-loan-simulate")
  LoanSimulateID? mount(LoanSimulate, { target: LoanSimulateID }):null;

  const LayoutContentID = document.querySelector(".top-content-container")
  LayoutContentID? mount(LayoutContent, { target: LayoutContentID }):null;

  // カスタムエレメントの中に吐き出される予定のものは待機させる
  mountWhenReady("page-debitcard-guide-howto", DebitcardGiudeHowto);
  mountWhenReady("page-debitcard-guide-about", DebitcardGuideAbout);
  mountWhenReady("page-debitcard-guide-place", DebitcardGuidePlace);
  mountWhenReady("page-loan-guide-fixed-repayment", LoanGiudeFixedRepayment);
  mountWhenReady("page-loan-guide-repayment-simulation", LoanGiudeRepaymentSimulation);
  mountWhenReady("page-loan-guide-increase", LoanGiudeIncrease);
})

let lastScrollY = window.scrollY;
let ticking = false;
const HeaderEL = document.getElementById("layout-header");//business/でのエラー防止

if(HeaderEL){
  const updateHeader = () => {
    const currentScrollY = window.scrollY;
    const headerHeight = HeaderEL.offsetHeight;
    const isFixedBannerVisible = currentScrollY > window.innerHeight;
    const isScrollingDown = currentScrollY > lastScrollY;
    if (isScrollingDown && currentScrollY > headerHeight) {
      HeaderEL.style.transform = `translateY(-${headerHeight}px)`;
    } else {
      if (isFixedBannerVisible) {
        HeaderEL.style.transform = "translateY(0)";
      } else {
        HeaderEL.style.transform = "translateY(0)";
      }
    }

    if (currentScrollY <= 0) {
      HeaderEL.style.transform = "translateY(0)";
    }

    lastScrollY = currentScrollY < 0 ? 0 : currentScrollY;
    ticking = false;
  };

  window.addEventListener("scroll", () => {
    if (!ticking) {
      window.requestAnimationFrame(updateHeader);
      ticking = true;
    }
  }, { passive: true });
}
